import styled from "styled-components";
import { device, sizeConstants } from "../../../globalStyles";

export const ReportHeaderWrap = styled.div`
  padding: 30px ${sizeConstants.mobileLRContainerPadding}px 0;
  max-width: ${sizeConstants.containerMaxWidth}px;
  margin: 0 auto;
  box-sizing: initial;

  ${device.desktop} {
    display: flex;
    justify-content: center;
  }

  ${device.containerMaxWidth} {
    padding: 30px 0 0;
  }
`;

export const ReportHeaderInnerWrap = styled.div`
  width: 100%;
  max-width: 1440px;
`;

export const ReportHeaderContentContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 28px 0 10px;
`;
